<template>
  <div>
    <b-modal id="bv-modal-change-timezone" size="lg" hide-footer>
      <template #modal-title>Change Timezone</template>

       <v-select
    v-model="user.timezone"
    :options="timezones"
    label="name" 
    @input="formatTimezone"
    class="form-control2">
    <template #option="{ name }">
      <span>{{ name }}</span>
    </template>
  </v-select>

  <div class="pt-3">
    <button v-if="saving" type="button" class="btn btn-danger col"><i class="fas fa-spinner fa-spin"></i></button>
    <button v-else type="button" class="btn btn-danger col" @click="saveTimezone">Save</button>
  </div>

    </b-modal>
  </div>
</template> 

<script>
import { EventBus } from '../bus';

export default {
props: ['user'],
  data() {
    return {
      timezones: [],
      updating: false,
      saving: false,
    };
  },

  created() {
    this.getTimezones();
  },

  methods: {

    getTimezones() {

      this.loading = true;

      axios.get(`/timezones`).
      then((response) => {
        this.timezones = response.data;
      }).catch((error) => {
        this.sweetfire(error.response.data.message);
        this.loading = false;
      });

    },

    hideModalChangeTimezone() {
      this.$bvModal.hide('bv-modal-change-timezone');
    },

            saveProfile() {

             this.updating = true;

              axios.post('/profile/save', {
                name: this.user.name,
                surname: this.user.surname,
                email: this.user.email,
              })
               .then((response) => {

            if (response.data.success) {
                   EventBus.$emit('profile-updated', {
                      name: this.user.name,
                      surname: this.user.surname,
                      email: this.user.email,
                   });
                   this.successAlert(response.data.message);
                   this.hideModalEditBanking();
               } else {
                   this.sweetfire(response.data.message);
               }

              this.updating = false;

            });

          },

        formatTimezone() {
            if (this.user.timezone && typeof this.user.timezone === 'object') {
                this.user.timezone = this.user.timezone.value;
            }
        },

    saveTimezone() {

      if (this.user.timezone==null) { this.sweetfire('Please choose your timezone'); return; }

      this.saving = true;

      axios.post('/profile/timezone', {
        timezone: this.user.timezone
        }).
      then((response) => {
        this.hideModalChangeTimezone();
      }).catch((error) => {
        this.sweetfire(error.response.data.message);
      }).finally(() => {
        this.saving = false;
      });

    },

      // sweet alert for 3 seconds
      successAlert(text) {

        Swal.fire({
            title: text,
            customClass: {
                title: "popup-title",
                icon: 'custom-icon-size'
            },
            icon: 'success',
            showConfirmButton: false,
            timer: 3000,
            });
      },

      sweetfire(text) {

      Swal.fire({
      title: text,
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: true,
      focusConfirm: false,
      cancelButtonText: 'Ok',
      customClass: { title: "popup-title" },
    })
    
    },

  },
};
</script>

<style scoped>
textarea.form-control { font-size: 0.9rem !important; }
</style>